import { Button, Typography } from '@/shared/ui';
import { Link } from '@tanstack/react-router';
import { type FC } from 'react';

export const NotFoundPage: FC = () => {
  return (
    <div className="bg-neutral-1 border-neutral-4 flex w-[600px] flex-col gap-6 border p-10">
      <div className="flex flex-col gap-2 text-center">
        <Typography variant="h1" weight="medium">
          404
        </Typography>

        <Typography variant="body" weight="regular" className="opacity-85">
          Oops, This Page Not Found!
        </Typography>
      </div>

      <Link to="/">
        <Button fullWidth size="large">
          Go Back Home
        </Button>
      </Link>
    </div>
  );
};
